import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import _extends from '@babel/runtime/helpers/extends';
import { mapIcon, getTextColor } from './shared.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getIsTwoLine = function getIsTwoLine(props) {
  return !!props.caption;
};
var getFlexDirection = function getFlexDirection(isTwoLine) {
  return isTwoLine ? 'column' : 'row';
};
var getLabelTypography = function getLabelTypography(isTwoLine) {
  return isTwoLine ? 'body-s-strong' : 'body-s';
};
var getCaptionColor = function getCaptionColor(selection, state, exp) {
  var isMigratingChipToAccessibleColor = exp === null || exp === void 0 ? void 0 : exp.isMigratingChipToAccessibleColor;
  if (state === 'disabled') return 'base.disabled';
  if (selection === 'selected') {
    return isMigratingChipToAccessibleColor ? 'product.on.primary.subtle' : 'product.primary';
  }
  return 'base.subtle';
};
var mapBaseChipProps = function mapBaseChipProps(props) {
  var rest = _extends({}, (_objectDestructuringEmpty(props), props));
  return _objectSpread({
    flexDirection: getFlexDirection(getIsTwoLine(props))
  }, rest);
};
var getIconIdAfterState = function getIconIdAfterState(iconId, props) {
  var selection = props.selection,
    dismissible = props.dismissible;
  return selection === 'selected' && !dismissible && !getIsTwoLine(props) ? 'fill.symbol.check' : iconId;
};
var mapLeadingIcon = function mapLeadingIcon(props, exp) {
  var leadingIcon = props.leadingIcon;
  if (!leadingIcon) return undefined;
  var iconProps = mapIcon(props, getIconIdAfterState(leadingIcon, props), getIsTwoLine(props), exp);
  return iconProps && _objectSpread(_objectSpread({}, iconProps), {}, {
    me: '8'
  });
};
var getRatingIconId = function getRatingIconId(type) {
  if (type === 'rating-star') return 'fill.symbol.star';
  if (type === 'rating-circle') return 'fill.symbol.circle';
  return undefined;
};
var mapRatingIconInChip = function mapRatingIconInChip(props, exp) {
  var type = props.type,
    caption = props.caption;
  if (caption) return undefined;
  var ratingIcon = getRatingIconId(type);
  if (!ratingIcon) return undefined;
  var iconProps = mapIcon(props, getIconIdAfterState(ratingIcon, props), getIsTwoLine(props), exp);
  return iconProps && _objectSpread(_objectSpread({}, iconProps), {}, {
    ms: '8'
  });
};
var mapRatingIconInLabel = function mapRatingIconInLabel(props, exp) {
  var type = props.type,
    caption = props.caption;
  if (caption) {
    var ratingIcon = getRatingIconId(type);
    if (!ratingIcon) return undefined;
    var iconProps = mapIcon(props, getIconIdAfterState(ratingIcon, props), getIsTwoLine(props), exp);
    return iconProps && _objectSpread(_objectSpread({}, iconProps), {}, {
      ms: '8'
    });
  }
  return undefined;
};
var mapLabel = function mapLabel(props, exp) {
  var selection = props.selection,
    state = props.state;
  return {
    tag: 'span',
    variant: getLabelTypography(getIsTwoLine(props)),
    textAlign: 'start',
    lineClamp: 1,
    textColor: getTextColor(selection, state, exp)
  };
};
var mapCaption = function mapCaption(props, exp) {
  var caption = props.caption,
    selection = props.selection,
    state = props.state;
  if (!caption) return undefined;
  var typographyProps = {
    tag: 'span',
    variant: 'caption-default',
    textAlign: 'start',
    lineClamp: 1,
    textColor: getCaptionColor(selection, state, exp)
  };
  return {
    captionText: caption,
    typographyProps: typographyProps
  }; // Ensure captionText can be a string or undefined
};

export { mapBaseChipProps, mapCaption, mapLabel, mapLeadingIcon, mapRatingIconInChip, mapRatingIconInLabel };
//# sourceMappingURL=Chip.mappers.js.map
